(function() {
    var home = document.querySelector('[data-yx-home]');
    if (!home) return;

    function syncOwnerZoomHeroLayout() {
      /* Chrome on the owner's Retina Mac reports dpr=1.5 at 75% page zoom.
         That creates a virtual >=1920px viewport, but the visible hero must
         retain the same bottom-anchored laptop composition as at 80%. */
      var isMac = /Mac/.test(navigator.platform || '');
      var isOwnerZoom75 = isMac
        && window.devicePixelRatio >= 1.45
        && window.devicePixelRatio <= 1.55
        /* Chrome may report the 1920 owner canvas as 1919px after reserving
           the vertical scrollbar. Treat that one-pixel rounding as the same
           75% state; do not widen the rule into ordinary laptop layouts. */
        && window.innerWidth >= 1900;

      home.toggleAttribute('data-yx-owner-zoom-75', isOwnerZoom75);
    }

    syncOwnerZoomHeroLayout();
    window.addEventListener('resize', syncOwnerZoomHeroLayout, { passive: true });
  })();

function yxScrollHomeArticles(control) {
    if (!control) return;

    var section = control.closest('.yx-home__articles');
    if (!section) return;

    var track = section.querySelector('[data-yx-home-article-track]');
    if (!track) return;

    var direction = control.hasAttribute('data-yx-home-article-prev') ? -1 : 1;
    var firstCard = track.querySelector('article');
    var step = firstCard ? firstCard.getBoundingClientRect().width + 15 : 331;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    track.scrollBy({ left: direction * step, behavior: reduceMotion ? 'auto' : 'smooth' });
  }

  function yxSyncHomeArticleControls(section) {
    if (!section) return;

    var track = section.querySelector('[data-yx-home-article-track]');
    if (!track) return;

    var previous = section.querySelector('[data-yx-home-article-prev]');
    var next = section.querySelector('[data-yx-home-article-next]');
    var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    if (previous) previous.disabled = track.scrollLeft <= 1;
    if (next) next.disabled = maxScroll <= 1 || track.scrollLeft >= maxScroll - 1;
  }

  function yxInitHomeArticleControls() {
    document.querySelectorAll('.yx-home__articles').forEach(function(section) {
      var track = section.querySelector('[data-yx-home-article-track]');
      if (!track) return;
      track.addEventListener('scroll', function() {
        yxSyncHomeArticleControls(section);
      }, { passive: true });
      yxSyncHomeArticleControls(section);
    });
  }

  function yxScrollHomeCarousel(control) {
    if (!control) return;

    var target = control.getAttribute('data-yx-home-carousel-target');
    if (!target) return;

    var section = control.closest('.yx-home');
    if (!section) return;

    var track = section.querySelector('[data-yx-home-carousel-track="' + target + '"]');
    if (!track) return;

    var direction = control.hasAttribute('data-yx-home-carousel-prev') ? -1 : 1;
    var firstCard = track.children && track.children[0];
    var trackStyles = window.getComputedStyle(track);
    var gap = parseFloat(trackStyles.columnGap || trackStyles.gap || '0') || 15;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var step = firstCard ? firstCard.getBoundingClientRect().width + gap : track.clientWidth;
    track.scrollBy({ left: direction * step, behavior: reduceMotion ? 'auto' : 'smooth' });
  }

  /* Page zoom changes the layout viewport and therefore the Gear System
     scrollport. Do not retain an old end-position against the new geometry:
     that state exposes a clipped leading card and makes the section appear
     to slide inside a second container. */
  var yxHomeSystemResizeFrame = 0;
  var yxHomeSystemResizeTimer = 0;

  function yxResetHomeSystemTracks() {
    document.querySelectorAll('[data-yx-home-system-track]').forEach(function(track) {
      track.scrollTo({ left: 0, behavior: 'auto' });
    });
  }

  window.addEventListener('resize', function() {
    window.cancelAnimationFrame(yxHomeSystemResizeFrame);
    window.clearTimeout(yxHomeSystemResizeTimer);
    yxHomeSystemResizeFrame = window.requestAnimationFrame(yxResetHomeSystemTracks);
    /* Chrome applies page-zoom geometry after the first resize frame. Repeat
       once after that layout settles so its own scroll restoration cannot
       put the rail back between two cards. */
    yxHomeSystemResizeTimer = window.setTimeout(yxResetHomeSystemTracks, 180);
  }, { passive: true });

  function yxGoToHomeStripeSlide(control) {
    if (!control) return;

    var section = control.closest('.yx-home__stripe');
    if (!section) return;

    var track = section.querySelector('[data-yx-home-stripe-track]');
    if (!track) return;

    var dots = Array.prototype.slice.call(section.querySelectorAll('[data-yx-home-stripe-dot]'));
    var index = dots.indexOf(control);
    if (index < 0) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    track.scrollTo({ left: index * track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
  }

  function yxSyncHomeStripeDots(track) {
    var section = track.closest('.yx-home__stripe');
    if (!section) return;

    var dots = section.querySelectorAll('[data-yx-home-stripe-dot]');
    var index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
    for (var i = 0; i < dots.length; i++) {
      if (i === index) dots[i].setAttribute('aria-current', 'true');
      else dots[i].removeAttribute('aria-current');
    }
  }

  function yxCloseHomePromo(control) {
    if (!control) return;
    var prompt = control.closest('.yx-home__hero-tab');
    if (prompt) prompt.hidden = true;
  }

  function yxOpenHomePromo(control) {
    if (!control) return;
    var hero = control.closest('[data-yx-home]');
    var modal = hero && hero.querySelector('[data-yx-home-promo-modal]');
    if (!(modal instanceof HTMLDialogElement) || modal.open) return;

    modal.showModal();
  }

  function yxCloseHomePromoModal(control) {
    if (!control) return;
    var modal = control.closest('[data-yx-home-promo-modal]');
    if (modal instanceof HTMLDialogElement) modal.close();
  }

  function yxOpenHomePromoResponse() {
    var submittedModalId = '';
    try {
      submittedModalId = window.sessionStorage.getItem('yx-home-promo-submitted') || '';
      window.sessionStorage.removeItem('yx-home-promo-submitted');
    } catch (_) {}
    if (!submittedModalId) return;
    var submittedModal = document.getElementById(submittedModalId);
    var response = submittedModal && submittedModal.querySelector('[data-yx-home-promo-response]');
    var modal = response && response.closest('[data-yx-home-promo-modal]');
    if (modal instanceof HTMLDialogElement && !modal.open) modal.showModal();
  }

  document.addEventListener('submit', function(event) {
    var form = event.target.closest('.yx-home__promo-modal-form');
    var modal = form && form.closest('[data-yx-home-promo-modal]');
    if (!form || !modal?.id) return;
    try {
      window.sessionStorage.setItem('yx-home-promo-submitted', modal.id);
    } catch (_) {}
  });

  document.addEventListener('click', function(event) {
    yxCloseHomePromo(event.target.closest('[data-yx-home-promo-close]'));
    var promoOpen = event.target.closest('[data-yx-home-promo-open]');
    if (promoOpen) {
      event.preventDefault();
      yxOpenHomePromo(promoOpen);
      return;
    }
    var promoModalClose = event.target.closest('[data-yx-home-promo-modal-close]');
    if (promoModalClose) {
      yxCloseHomePromoModal(promoModalClose);
      return;
    }

    yxScrollHomeCarousel(event.target.closest('[data-yx-home-carousel-prev], [data-yx-home-carousel-next]'));
    yxScrollHomeArticles(event.target.closest('[data-yx-home-article-prev], [data-yx-home-article-next]'));
    yxGoToHomeStripeSlide(event.target.closest('[data-yx-home-stripe-dot]'));
  });

  document.addEventListener(
    'scroll',
    function(event) {
      var track = event.target instanceof Element ? event.target.closest('[data-yx-home-stripe-track]') : null;
      if (track) yxSyncHomeStripeDots(track);
    },
    true
  );

  function yxInitMobileFaqState() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    document.querySelectorAll('.yx-home__faq details[open]').forEach(function(details) {
      details.removeAttribute('open');
    });
  }

  yxInitMobileFaqState();
  yxInitHomeArticleControls();
  window.addEventListener('resize', function() {
    document.querySelectorAll('.yx-home__articles').forEach(yxSyncHomeArticleControls);
  }, { passive: true });
  yxOpenHomePromoResponse();

/* Product-row arrows. One homepage JS owner. */
function yxSyncHomeRowArrows(track) {
  if (!track) return;

  var section = track.closest('.yx-home__products, .yx-home__comfort');
  if (!section) return;

  var prev = section.querySelector('[data-yx-home-row-prev]');
  var next = section.querySelector('[data-yx-home-row-next]');
  var maxScroll = track.scrollWidth - track.clientWidth;
  if (prev) prev.disabled = track.scrollLeft <= 2;
  if (next) next.disabled = maxScroll <= 2 || track.scrollLeft >= maxScroll - 2;
}

function yxScrollHomeProductRow(control) {
  if (!control) return;

  var section = control.closest('.yx-home__products, .yx-home__comfort');
  if (!section) return;

  var track = section.querySelector('ul, [data-yx-home-look-track]');
  if (!track) return;

  var direction = control.hasAttribute('data-yx-home-row-prev') ? -1 : 1;
  var firstCard = track.querySelector('li, article');
  var styles = window.getComputedStyle(track);
  var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
  var visibleCards = window.matchMedia('(min-width: 1200px)').matches ? 5 : 4;
  if (track.hasAttribute('data-yx-home-look-track')) visibleCards = 4;
  var step = firstCard ? (firstCard.getBoundingClientRect().width + gap) * visibleCards : track.clientWidth;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  track.scrollBy({ left: direction * step, behavior: reduceMotion ? 'auto' : 'smooth' });
}

function yxInitHomeRowArrows() {
  document.querySelectorAll('.yx-home__products > ul, .yx-home__comfort > ul, [data-yx-home-look-track]').forEach(yxSyncHomeRowArrows);
}

document.addEventListener('click', function(event) {
  yxScrollHomeProductRow(event.target.closest('[data-yx-home-row-prev], [data-yx-home-row-next]'));
});

document.addEventListener(
  'scroll',
  function(event) {
    var track = event.target instanceof Element ? event.target.closest('.yx-home__products > ul, .yx-home__comfort > ul, [data-yx-home-look-track]') : null;
    if (track) yxSyncHomeRowArrows(track);
  },
  true
);

yxInitHomeRowArrows();
requestAnimationFrame(yxInitHomeRowArrows);
setTimeout(yxInitHomeRowArrows, 400);
window.addEventListener('load', yxInitHomeRowArrows);
window.addEventListener('resize', yxInitHomeRowArrows);
